<template>
    <div class="top-right-slide" id="topRightSlide" ref="topRightSlide">
        <template v-for="(item,index) in promotionData">
            <div 
                v-if="item.adType" 
                class="top-right-item" 
                :data-spm-content="spmContent(item)"
                data-spm-strict="true"
                :data-spm-data="index+5"
                :data-id="item.resourceId"
                data-spm-type="resource"
            >
            </div>
            <a 
                v-else
                :key="item.id" class="top-right-item" :href="item.url" 
                :data-spm-content="spmContent(item)" 
                data-promo="true" 
                data-spm-strict="true" 
                ref="promote" 
                @click="handleClick(item, index)" 
                :data-spm-data="index+5">
                <img :src="item.images && item.images[0]" class="sprite-icons-video fl" alt="" v-if="item.images && item.images.length > 0">
                <span v-if="item.title">{{item.title}}</span>
            </a>
        </template>
    </div>
</template>

<script>
    import SlideV from '../utils/slide-v.js'
    import MptcfeUtils from "mptcfe-utils"
    import topRightAdItem from '../ad/components/SOHUZH/topRightAdItem.vue'
    import MptcfeWapAd from 'mptcfe-wap-ad'
    import { articleAdConfig } from '@/config/adConfig.js'
    import { getOdinData } from '@/js/request/odinRequest.js'

    const SpmActionCodeMap = {
        //请求返回上报
        PV: '7202',
        //曝光上报
        EV: '7203',
        //点击上报
        CLICK: '8358'
    }
    const Utils = MptcfeUtils.Utils
    const ExposureIns = new MptcfeUtils.Exposure(null, false)
    // 广告模板
    const adTemplateMap = {
        SOHUZH: {
            MixPic: topRightAdItem
        }
    }

    export default {
        name: 'topRightSlide',
        data () {
            return {
                promotionData: [],
                //素材轮换时间，会轮换全部素材
                timer: 1000,
                //滚动组件参数
                slideParam: {
                    wrapperSelector: '.top-right-slide',
                    //单帧停留时间，目前为3秒
                    slideTime: 1000 * 3,
                    //动画时间，目前为400毫秒
                    animateTime: 400,
                    itemSelector: '.top-right-item',
                    slideCallback: () => Utils.domDidChange({ target: 'hdn'}),
                },
                spmCode: window && window.sohuSpm && window.sohuSpm.getCodes && window.sohuSpm.getCodes(),
            }
        },
        async mounted () {
            try {
                const adConfig1 = articleAdConfig.topRightSlide1
                const adData1 = await this.renderAd(adConfig1)
                const adConfig2 = articleAdConfig.topRightSlide2
                const adData2 = await this.renderAd(adConfig2)
                this.$nextTick(() => {
                    adData1 && adData2 && new SlideV(this.slideParam)
                    let refsDoms = this.$refs.promote  || []
                    refsDoms.forEach((dom,index) => {
                        this.handleSendSpmAction(dom, this.promotionData[index], index)
                    })
                })
            } catch (error) {
                console.log('右上角推广位加载失败', error)
            }

        },
        methods: {
            spmContent (item) {
                return Utils.getSpmContent(item)
            },
            // 处理点击后的埋点上报
            handleClick(param, index) {
                MptcfeUtils.Utils.sendSpmAction(SpmActionCodeMap.CLICK, this.getReportInfo(param, index))
            },
            handleSendSpmAction(dom,param, index) {
                let opt = {
                    dom: dom,
                    isExposure: false,
                    callback: () => {
                        MptcfeUtils.Utils.sendSpmAction(SpmActionCodeMap.EV, this.getReportInfo(param, index))
                    },
                }
                ExposureIns.add(opt)
                ExposureIns.allExposureCheck()
                MptcfeUtils.Utils.sendSpmAction(SpmActionCodeMap.PV, this.getReportInfo(param, index))
            },
            getReportInfo(param, index){
                return `isPromo:true;pcm:${param.pcm};url:${encodeURIComponent(param.url)};location:${this.spmCode.a}.${this.spmCode.b}.nav.${index + 1}`
            },
            /**
             * @description 根据广告配置渲染广告
             * @param adConfig 
             */
            async renderAd(adConfig){
                if(!adConfig){
                    console.log('无广告配置,请检查adConfig.js中topSlide配置')
                    return
                }
                const { spmCCode, resourceId, posCode, rule, fixArray, index } = adConfig
                const param = {
                    tplCompKey: resourceId,
                    resourceId,
                    spmCCode,
                    adInfo: {
                        posCode,
                        rule,
                        fixArray
                    },
                    isSingleAd: true
                }
                try {
                    const data = await getOdinData(param)
                    const list = data?.list
                    const adData = list?.[0]?.resourceData
                    const adType = list?.[0]?.resourceData?.adType
                    if(!adData) return
                    this.promotionData.push({
                        ...adData,
                        resourceId: resourceId
                    })
                    this.$nextTick(()=>{
                        const AdGenerator = MptcfeWapAd.AdGenerator
                        const self = this
                        new AdGenerator({
                            data: adData,
                            location: `${spmCCode}.${index}`,
                            resourceId: resourceId,
                            component: adTemplateMap[adType],
                            success: adDom => {
                                console.log(resourceId, `顶部导航右侧广告${index}成功返回`, adDom)
                                if(adDom){
                                    self.$nextTick(()=>{
                                        const container = this.$refs.topRightSlide?.querySelector(`[data-id="${resourceId}"]`)
                                        if(container){
                                            container.appendChild(adDom)
                                        }else{
                                            console.log('顶部导航右侧广告',index,'找不到挂载点')
                                        }
                                    })
                                }
                            },
                            successEmpty: ()=>{
                                console.log(`顶部导航右侧${index}广告请求为空`)
                            },
                            error: () => {
                                console.log(`顶部导航右侧${index}广告请求error`)
                            },
                            timeout: () => {
                                console.log(`顶部导航右侧.${index}广告请求超时`)
                            },
                        })
                    })
                    return adData
                } catch (error) {
                    console.log(spmCCode,'顶部导航广告异常', error)
                    return
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .top-right-slide {
        height: 100%;
        overflow: hidden;
        .top-right-item {
            position: relative;
            height: 100%;
            display: flex !important;
            align-items: center;
            justify-content: flex-end;
            .sprite-icons-video {
                display: block;
                background: unset;
                background-size: contain;
                max-width: 250px; /*px*/
                height: 30px; /*px*/
                width: auto !important;
            }
            span {
                font-size: 28px;/*px*/
                line-height: 40px;
                color: #111111;
                max-width: 195px;/*px*/
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-left: 6px;
            }
        }
    }
</style>